import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const images = ['https://cdn.magicpatterns.com/uploads/ugNpL6y5TWVJwHhqZd8zjw/Screenshot_2026-06-13_at_8.24.32_PM.png', 'https://cdn.magicpatterns.com/uploads/b82tGyktcu8Lu9YQTyUheX/Screenshot_2026-06-13_at_8.24.45_PM.png', 'https://cdn.magicpatterns.com/uploads/bDStExHc5kVui1xniaqyQN/Screenshot_2026-06-13_at_8.24.55_PM.png', 'https://cdn.magicpatterns.com/uploads/kYKXFkU6BDUz6Wn2RxqT86/Screenshot_2026-06-13_at_8.28.02_PM.png', 'https://cdn.magicpatterns.com/uploads/tp32P5ScHochb913fPyszE/Screenshot_2026-06-13_at_8.27.27_PM.png'];
export function PreviewCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => setCurrentIndex(prev => (prev + 1) % images.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
  return <section className="py-20 bg-pastel-100 text-navy-900 px-4" data-id="element-143">
      <div className="max-w-5xl mx-auto" data-id="element-144">
        <div className="text-center mb-12" data-id="element-145">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-navy-900" data-id="element-146">
            👀 Qué te vas a encontrar dentro
          </h2>
        </div>

        <div className="relative max-w-3xl mx-auto" data-id="element-147">
          {/* Carousel Container */}
          <div className="relative aspect-[4/3] md:aspect-[16/10] bg-white rounded-2xl overflow-hidden shadow-2xl border border-pastel-200" data-id="element-148">
            <AnimatePresence mode="wait" data-id="element-149">
              <motion.a key={currentIndex} href="#compra" initial={{
              opacity: 0,
              x: 50
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -50
            }} transition={{
              duration: 0.3
            }} className="absolute inset-0 block cursor-pointer" data-id="element-150">
                <img src={images[currentIndex]} alt={`Preview ${currentIndex + 1}`} className="w-full h-full object-contain bg-white" data-id="element-151" />
              </motion.a>
            </AnimatePresence>

            {/* Navigation Arrows */}
            <button onClick={e => {
            e.preventDefault();
            prev();
          }} className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-navy-800/90 hover:bg-navy-800 text-white rounded-full flex items-center justify-center backdrop-blur-sm transition-colors" data-id="element-152">
              <ChevronLeft size={24} data-id="element-153" />
            </button>
            <button onClick={e => {
            e.preventDefault();
            next();
          }} className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-navy-800/90 hover:bg-navy-800 text-white rounded-full flex items-center justify-center backdrop-blur-sm transition-colors" data-id="element-154">
              <ChevronRight size={24} data-id="element-155" />
            </button>
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-6" data-id="element-156">
            {images.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2.5 h-2.5 rounded-full transition-colors ${idx === currentIndex ? 'bg-navy-800' : 'bg-pastel-300 hover:bg-pastel-400'}`} data-id="element-157" />)}
          </div>

          <div className="text-center mt-8" data-id="element-158">
            <p className="text-sm text-navy-600 italic" data-id="element-159">
              Toca cualquier imagen para obtener tu manual
            </p>
          </div>
        </div>
      </div>
    </section>;
}